import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';

function AdminDashboard() {
  const [stats, setStats] = useState({
    users: 0,
    menuItems: 0,
    galleryItems: 0,
    testimonials: 0
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    
    // Load stats
    Promise.all([
      apiService.getUsers(token),
      apiService.getMenuItems(),
      apiService.getGallery(),
      apiService.getTestimonials()
    ]).then(([users, menu, gallery, testimonials]) => {
      setStats({
        users: users.data.users.length,
        menuItems: menu.data.items.length,
        galleryItems: gallery.data.gallery.length,
        testimonials: testimonials.data.testimonials.length
      });
    }).catch(error => {
      console.error('Error loading stats:', error);
    });
  }, []);

  return (
    <div>
      <h2>Dashboard Overview</h2>
      
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '30px'}}>
        <div className="admin-card" style={{textAlign: 'center'}}>
          <h3 style={{fontSize: '3rem', color: 'var(--primary-blue)', marginBottom: '10px'}}>{stats.users}</h3>
          <p style={{fontSize: '1.2rem', color: '#666'}}>Users</p>
        </div>
        
        <div className="admin-card" style={{textAlign: 'center'}}>
          <h3 style={{fontSize: '3rem', color: 'var(--primary-blue)', marginBottom: '10px'}}>{stats.menuItems}</h3>
          <p style={{fontSize: '1.2rem', color: '#666'}}>Menu Items</p>
        </div>
        
        <div className="admin-card" style={{textAlign: 'center'}}>
          <h3 style={{fontSize: '3rem', color: 'var(--primary-blue)', marginBottom: '10px'}}>{stats.galleryItems}</h3>
          <p style={{fontSize: '1.2rem', color: '#666'}}>Gallery Items</p>
        </div>
        
        <div className="admin-card" style={{textAlign: 'center'}}>
          <h3 style={{fontSize: '3rem', color: 'var(--primary-blue)', marginBottom: '10px'}}>{stats.testimonials}</h3>
          <p style={{fontSize: '1.2rem', color: '#666'}}>Testimonials</p>
        </div>
      </div>
      
      <div className="admin-card" style={{marginTop: '30px'}}>
        <h2>Welcome to Yamas CMS</h2>
        <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: '#666'}}>
          Manage your restaurant website content, menu items, gallery, user accounts, and settings from this admin panel. 
          Use the navigation menu on the left to access different sections.
        </p>
      </div>
    </div>
  );
}

export default AdminDashboard;
